export function isMessengerMessage(message) {
    return (typeof message === 'object' &&
        message !== null &&
        'channel' in message &&
        message.channel === 'messenger');
}
const stringifyFieldValue = (field) => {
    if (typeof field.value === 'string')
        return field.value;
    if (field.label === 'Files') {
        const { files } = field.value.FileFieldResponseValue;
        return files
            .map(({ url, pretty_name }) => `[${pretty_name}](${url})`)
            .join(', ');
    }
    return '';
};
function parseMessengerFormContent({ messenger_form_request, }) {
    var _a, _b;
    try {
        const formResponse = JSON.parse(messenger_form_request);
        const fieldsWithResponses = (_a = formResponse === null || formResponse === void 0 ? void 0 : formResponse.fields.flatMap(Object.values).filter((field) => field.value !== null).map(stringifyFieldValue).join('\n')) !== null && _a !== void 0 ? _a : '';
        return {
            title: `[${(_b = formResponse === null || formResponse === void 0 ? void 0 : formResponse.labels.title) !== null && _b !== void 0 ? _b : ''} form]`,
            description: fieldsWithResponses,
        };
    }
    catch (error) {
        return {
            title: 'Form',
            description: '',
        };
    }
}
function parseMessengerContentWithTitle({ text, messenger_title, messenger_choices, }) {
    if (messenger_title) {
        return { title: messenger_title, description: text !== null && text !== void 0 ? text : '' };
    }
    return { title: text !== null && text !== void 0 ? text : '', description: '' };
}
function parseMessengerMenuContent({ text, messenger_title, messenger_choices, }) {
    try {
        const choices = JSON.parse(messenger_choices);
        const choicesString = choices
            .map(({ text }, index) => `${index + 1}. ${text}`)
            .join(' ');
        return {
            title: messenger_title || text || 'Choices',
            description: choicesString,
        };
    }
    catch (error) {
        return {
            title: 'Choices',
            description: '',
        };
    }
}
export function parseMessengerMessageContent(message) {
    var _a;
    if (message.messenger_form_request) {
        const { title, description } = parseMessengerFormContent(message);
        return buildMessageContentString(title, description);
    }
    if (message.messenger_choices) {
        const { title, description } = parseMessengerMenuContent(message);
        return buildMessageContentString(title, description);
    }
    if (message.messenger_title) {
        const { title, description } = parseMessengerContentWithTitle(message);
        return buildMessageContentString(title, description);
    }
    return (_a = message.text) !== null && _a !== void 0 ? _a : '';
}
function buildMessageContentString(title, description) {
    if (title) {
        return `${title} ${description}`;
    }
    return description !== null && description !== void 0 ? description : '';
}
